<template>
  <el-upload
    ref="uploadRef"
    v-model:file-list="imageList"
    :class="{ hide_box: imageList.length == limit }"
    :headers="token"
    action="/auth/system/file/upload"
    list-type="picture-card"
    :limit="limit"
    :multiple="limit != 1"
    :accept="accept"
    :data="uploadData"
    :on-success="handleSuccess"
    :on-exceed="handleExceed"
    :before-upload="handleBeforeUpload"
  >
    <div class="upload-icon">
      <el-icon class="upload-plus">
        <Plus />
      </el-icon>
      <div class="upload-text">添加图片</div>
    </div>

    <template #file="{ file }">
      <img :src="file.url" alt="" />
      <div class="upload-bezel">
        <div class="mask"></div>
        <div class="upload-img-list">
          <img
            v-if="statusTyle.includes(1)"
            src="https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20250313/XZeEscS3IusPKRCO.png"
            alt=""
            @click="handlePictureCardPreview(file)"
          />
          <img
            v-if="statusTyle.includes(2)"
            src="https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20250313/mY9Yc3wOIJjkyYyc.png"
            alt=""
            @click="handleReplace(file)"
          />
          <img
            v-if="statusTyle.includes(3)"
            src="https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20250313/FcWNh3IQXs7G0uKT.png"
            alt=""
            @click="handleRemove(file)"
          />
        </div>
      </div>
    </template>
  </el-upload>
  <!-- 图片查看器 -->
  <el-image-viewer
    v-if="showViewer"
    :initial-index="index"
    @close="closeViewer"
    :url-list="urlList"
  />
</template>
<script lang="ts" setup>
import {
  ref,
  defineComponent,
  onMounted,
  getCurrentInstance,
  nextTick,
} from "vue";
import { Plus } from "@element-plus/icons-vue";
import { genFileId } from "element-plus";
import { ElMessage } from "element-plus";
import type {
  UploadProps,
  UploadFile,
  UploadFiles,
  UploadRawFile,
} from "element-plus";

const app = getCurrentInstance()?.proxy;
const uploadRef = ref();

const props = defineProps({
  list: {
    type: Array,
    default: () => {
      return [];
    },
  },
  // 上传数量
  limit: {
    type: Number,
    default: 2,
  },
  accept: {
    type: String,
    default: ".png,.jpg,.jpeg",
  },
  // 图片大小 -1 不限制
  size: {
    type: Number,
    default: -1,
  },
  // 额外 上传数据
  uploadData: {
    type: Object,
    default: () => {
      return {};
    },
  },
  // 鼠标移入显示的状态类型 1查看 2编辑 3删除
  statusTyle: {
    type: Array,
    default: () => {
      return [1, 2, 3];
    },
  },
});

const emit = defineEmits<{
  (event: "update:list", params: Array<string>): void;
}>();

const token = ref({
  Authorization: localStorage.getItem("token"),
});

const imageList = ref<any[]>([]);

const handleSuccess = (
  response: any,
  uploadFile: UploadFile,
  uploadFiles: any
) => {
  imageList.value = uploadFiles.map((v: any) => {
    if (v.response) {
      v.url = `https://wepaas.oss-cn-shenzhen.aliyuncs.com/${v.response.data.url}`;
    }
    return v;
  });
  emit("update:list", imageList.value);
};

const isIntercept = ref(false);
const handleBeforeUpload = (rawFile: UploadRawFile) => {
  console.log(rawFile);

  const imgSize = rawFile.size;
  if (props.size != -1 && imgSize / 1024 / 1024 > props.size) {
    app?.$message.error(`图片最大可上传${props.size}M`);
    isIntercept.value = false;
    return false;
  }
  isIntercept.value = true;
  return true;
};

const showViewer = ref(false); // 图片弹窗控制预览
const urlList = ref<string[]>([]); // 图片预览
const index = ref(0);

// 图片查看器
const handlePictureCardPreview = (file: UploadFile) => {
  urlList.value = imageList.value.map((item: any) => item.url);
  index.value = imageList.value.findIndex((item: any) => item.url === file.url);
  showViewer.value = true;
  document.body.style.overflow = "hidden";
};

// 关闭图片查看器
const closeViewer = () => {
  showViewer.value = false;
  document.body.style.overflow = "auto";
};

// 删除图片
const handleRemove = (file: UploadFile) => {
  imageList.value = imageList.value.filter(
    (item: any) => item.url !== file.url
  );
  emit("update:list", imageList.value);
};

const isEdit = ref(false);
// 更换图片
const handleReplace = (file: UploadFile) => {
  isEdit.value = true;
  onUploadImg(file);
  isEdit.value = false;
};

// 更换图片超出顶替
const handleExceed = (files: UploadFile) => {
  if (!isEdit.value) {
    ElMessage.warning(`最多只能上传${props.limit}张图片`);
    return;
  }
  const file = files[0] as UploadRawFile;
  file.uid = genFileId();
  uploadRef.value!.handleStart(file);
  uploadRef.value!.submit();
};

// 手动调取本地上传入口
const onUploadImg = (file: UploadFile) => {
  const input = uploadRef.value.$el.querySelector("input");
  input.click();
  input.onchange = () => {
    const idx = imageList.value.findIndex((v) => v.url === file.url);
    const endIdx = imageList.value.length !== props.limit;
    // 判断是替换还是新增
    if (idx != -1 && isIntercept.value) {
      // 此处顺序不能调换
      endIdx &&
        imageList.value.splice(
          idx,
          0,
          imageList.value[imageList.value.length - 1]
        );
      handleRemove(file);
      endIdx && imageList.value.pop();
    }
  };
};
</script>
<style lang="scss" scoped>
:deep(.el-upload--picture-card) {
  width: 84px;
  height: 84px;
  background: $--color-module-bg;
  border-radius: 4px;
  border: 1px solid $--color-main;
}
:deep(.el-upload-list__item) {
  width: 84px;
  height: 84px;
  border: none;
  border-radius: 4px;
  margin: 0 20px 20px 0;
  display: flex;
  justify-content: center;
  position: relative;
  .upload-bezel {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    &:hover {
      .mask {
        display: block;
      }
      .upload-img-list {
        display: flex;
      }
    }
    .mask {
      width: 100%;
      height: 100%;
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 84px;
      height: 84px;
      background: #000000;
      border-radius: 4px;
      opacity: 0.4;
    }
    .upload-img-list {
      width: 100%;
      height: 100%;
      display: none;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      left: 0;
      img {
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
    }
  }
}
.upload-icon {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  .upload-text {
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: $--color-tips-text;
    margin-top: 8px;
  }
}
.hide_box :deep(.el-upload--picture-card) {
  display: none;
}
</style>
